   // Function to check and process elements
  function checkElements() {
  const elements = document.querySelectorAll('.embedAppSection');
  if (elements.length > 0) {
    // Elements found - run comparison
    elements.forEach(element => {
      if (element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.card__badge.bottom.left').innerText === 'Sale') {
        // Your custom logic here
        // 2. Select the NEW parent (must exist in the DOM)
        const newParent = element.parentElement.parentElement.parentElement;
        // 3. Remove from current location
        element.remove();
    
        // 4. Append to new parent
        newParent.appendChild(element);
      }
    });
    return true; // Return true if elements were found
  }
  return false; // Return false if no elements found
  
}

  document.addEventListener("DOMContentLoaded", async function () {

 
  // Wait 1500ms before running the check
setTimeout(() => {
checkElements();
  }, 1500); // 1500ms delay

  });